<template lang="pug">
div.px-8
  v-row(no-gutters)
    v-col.pr-8.shrink
      div.sticky.white(style="width: 150px; top: 106px;")
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/inventory')") Inventory
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/services')") Services
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/packages')") Packages
        .text-md.font-semibold.neutral200.px-6.py-2.round-md.mb-2 Stock take
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(v-if="company.is_hq || company.branch_of" @click="$router.push('/admin/clinic/branches-warehouses')") Branches & Warehouses
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/locations')") Locations
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(v-if="Auth('root', 'subscribe_purchase_hub')" @click="$router.push('/admin/clinic/inventory-list')") List

    v-col.grow
      v-container.py-8(fluid)
        v-row.mb-2(no-gutters align="center")
          v-col.shrink
            v-btn.ml-n3(text icon @click="goBack" height)
              v-icon(color="neutral700" :size="24") mdi-arrow-left
          v-col.ml-3
            .text-2xl.font-semibold.neutral700--text Stock take
        v-row.pb-2.pb-md-0(no-gutters)
          v-col(cols="12" md="6")
            v-tabs(v-model="tabs" color="basic700" :height="44" :grow="isMobileScreen" active-class="font-semibold" @change="tabChanged(tabs)")
              v-tab.text-sm.font-medium.text-none.px-4 {{ $t('all') }}
              v-tab.text-sm.font-medium.text-none.px-4 Archived
          v-col(cols="12" md="6" align="end")
            .d-flex.align-center
              v-spacer
              v-btn(@click="clickSearch" icon color="neutral500")
                v-icon(size="20") $yzi-search-sm
              v-text-field(v-if="showSearchField" v-model="searchText" @blur="blurSearch" @input="queryChanged" solo dense flat placeholder="Type to search..." hide-details clearable autofocus)
              div
                customize-column-menu(type="stocktake" :showTooltip="false" iconSize="21")
              y-button.ml-3(label="Start stock take" size="sm" @click="startStockTake")
        v-divider

        filter-stocktakes-row.my-2(ref="filter" :filters.sync="filters" :prop-filters="saveFilters")
        v-expand-transition
        .d-flex.align-center.mt-4(v-if="checkedStocktakes.length")
          v-btn.button-Aa-small.mr-3.px-3(@click="openMultiArchiveDialog = true" color="danger500" outlined height=32 depressed) Archive
          v-btn.button-Aa-small.mr-3.px-3(@click="bulkDownload" color="primary" height=32 depressed) Download report PDF
          a.link-s(@click="clearSelection") {{ $t('clear_selection') }}

        .data-table
          v-data-table.mt-sm-4.pb-6(:headers="headers" :items="stocktakes" item-key="id" :items-per-page="pageSize" hide-default-footer :loading="isFetching" :disable-sort="isMobileScreen" :header-props="{ sortIcon: '$yzi-triangle' }" @click:row="selectStocktake")
            template(v-slot:header.checked)
              yc-checkbox(v-model="checkAll" @change="onCheckedAll")
            //- checked
            template(v-slot:item.checked="{ item }")
              div
                yc-checkbox(v-model="item.checked" @change="onChecked")
            //- name
            template(v-slot:item.name="{ item }")
              .text-sm.neutral700--text {{ item.name }}
            //- user
            template(v-slot:item.user="{ item }")
              .text-sm.neutral700--text {{ item.member.name }}
            //- inventories
            template(v-slot:item.inventory="{ item }")
              .text-sm.neutral700--text(v-if="item.products.length") {{ item.products.length }}
              .text-sm.neutral700--text(v-else) -
            //- start date
            template(v-slot:item.start_date="{ item }")
              div(v-if="item.created")
                .text-sm.neutral700--text {{ item.created | humanizeDate }}
                .text-xs.neutral700--text {{ item.created | displayTime2 }}
              .text-sm.neutral700--text(v-else) -
            //- end date
            template(v-slot:item.end_date="{ item }")
              div(v-if="item.finished_at")
                .text-sm.neutral700--text {{ item.finished_at | humanizeDate }}
                .text-xs.neutral700--text {{ item.finished_at | displayTime2 }}
              .text-sm.neutral700--text(v-else) -
            //- status
            template(v-slot:item.status="{ item }")
              y-chip(v-if="item.archived" label="Archived" color="red")
              y-chip(v-else-if="item.status === 'in_progress'" label="In progress" color="orange")
              y-chip(v-else label="Finished" color="green")
            //- actions
            template(v-slot:item.actions="{ item, index }")
              div.d-flex.align-center.justify-end(@click.stop)
                y-button(v-if="item.status === 'finished'" label="PDF" size="sm" underline prepend-icon="$yzi-download-01" icon-color="neutral700" icon-size="20" @click="downloadReport(item)")
                y-button(v-else label="Continue" size="sm" underline @click="viewDetails(item)")
                v-menu(offset-y :top="menuPositionTop(index)" left attach rounded="lg")
                  template(#activator="{ on }")
                    v-btn(icon small v-on="on")
                      v-icon mdi-dots-horizontal
                  v-list.py-0
                    template(v-if="item.status === 'finished'")
                      v-list-item(@click="viewDetails(item)")
                        v-list-item-title.text-sm.basic800--text View details
                      v-divider
                    v-list-item(@click="updateArchive(item)")
                      v-list-item-title.text-sm(:class="!item.archived ? 'danger500--text' : 'success500--text'") {{ !item.archived ? 'Archive' : 'Activate' }}

        div.d-flex.align-center(v-if="totalCount > pageSize")
          v-spacer
          yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" attach menu-top @input="pageChanged")

  .dialogs
    new-stock-take-dialog(v-if="openStockTakeDialog" :open.sync="openStockTakeDialog")
    delete-confirmation-dialog(v-if="openArchiveDialog" :open.sync="openArchiveDialog" :loading="isLoading" @cancel="closed" @delete="confirmDelete")
      .text-lg.font-medium Archive stock take?
      .text-md.mt-4 This item will be transferred into “Archived” tab. Select “Confirm” to remove item.
    delete-confirmation-dialog(v-if="openMultiArchiveDialog" :open.sync="openMultiArchiveDialog" :loading="isLoading" @cancel="closed" @delete="confirmDelete(true)")
      .text-lg.font-medium Archive selected stock takes?
      .text-md.mt-4 This item will be transferred into “Archived” tab. Select “Confirm” to remove items.

</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { debounce } from '@/utils'
import NewStockTakeDialog from '@/components/clinic/inventory/stocktake/NewStockTakeDialog.vue'
import CustomizeColumnMenu from '@/components/connect/CustomizeColumnMenu.vue'
import DeleteConfirmationDialog from '@/components/clinic/dialogs/DeleteConfirmationDialog.vue'
import FilterStocktakesRow from '@/components/clinic/inventory/FilterStocktakesRow.vue'

export default {
  name: 'StockTakes',
  components: { NewStockTakeDialog, CustomizeColumnMenu, DeleteConfirmationDialog, FilterStocktakesRow },
  props: ['savePage', 'saveTab', 'saveSearch', 'saveFilters'],
  data: () => ({
    isFetching: false,
    isLoading: false,
    showSearchField: false,
    openStockTakeDialog: false,
    openArchiveDialog: false,
    openMultiArchiveDialog: false,
    checkAll: false,
    searchText: null,
    tabs: 0,
    selectedStocktake: null,
    pageSize: 20,
    totalCount: 0,
    currentPage: 1,
    stocktakes: [],
    filters: [],
    checkedStocktakes: [],
  }),
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters({
      company: 'getCompany',
      stocktakeFields: 'clinic/getStocktakeFields'
    }),
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
    headers () {
      const name = { text: 'Name', value: 'name', enable: true, class: 'text-table-header', }
      const checkbox = {
        text: '',
        value: 'checked',
        sortable: false,
        class: 'text-table-header',
      }
      const fields = this.stocktakeFields.filter(item => item.enable)
      fields.map(item => {
        item.text = item.field_name
        item.value = item.id
        item.class = 'text-table-header'
      })
      const actions = {
        text: '',
        value: 'actions',
        enable: true,
        sortable: false,
        width: 60,
        class: 'text-table-header',
      }
      return [checkbox, name, ...fields, actions]
    },
  },
  watch: {
    filters () {
      this.fetchFirstPage()
    },
  },
  mounted () {
    this.checkProps()
    if (this.saveFilters) {
      this.$refs.filter.setFilters()
    } else {
      this.fetchStockTakes()
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchStockTakes () {
      this.isFetching = true
      const params = {
        page_size: this.pageSize,
        page: this.currentPage
      }
      if (this.tabs === 0) { params.archived = false }
      if (this.tabs === 1) { params.archived = true }
      this.filters.forEach(filter => {
        params[filter.key] = filter.value
      })
      if (this.searchText) {
        params.search = this.searchText
      }
      this.$axios.get(`/clinics/${this.company.slug}/stock_takes`, { params })
        .then(resp => {
          this.stocktakes = resp.data.results
          this.totalCount = resp.data.count
        })
        .catch(err => {
          let message = err.response?.data?.detail
          if (message.includes('Invalid page')) {
            this.fetchFirstPage()
          }
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchFirstPage () {
      this.currentPage = 1
      this.fetchStockTakes()
    },
    clickSearch () {
      if (this.showSearchField) {
        if (!this.searchText || this.searchText.length === 0) {
          this.showSearchField = false
        }
      } else {
        this.showSearchField = true 
      }
    },
    blurSearch () {
      if (!this.searchText || this.searchText.length === 0) {
        this.showSearchField = false
      }
    },
    queryChanged: debounce(function () {
      this.fetchFirstPage()
    }, 750),
    pageChanged () {
      this.fetchStockTakes()
    },
    tabChanged () {
      this.clearSelection()
      this.searchText = null
      this.fetchFirstPage()
    },
    checkProps () {
      if (this.saveSearch) {
        this.searchText = this.saveSearch
        this.clickSearch()
      }
      if (this.savePage) {
        this.currentPage = this.savePage
      }
      if (this.saveTab) {
        this.tabs = this.saveTab
      }
    },
    selectStocktake (data) {
      // data.checked = !data.checked
      this.viewDetails(data)
    },
    onChecked () {
      this.checkedStocktakes = this.stocktakes.filter(item => item.checked === true)
      this.stocktakes = [...this.stocktakes]
      this.checkAll = false
    },
    onCheckedAll () {
      const clone = [...this.stocktakes]
      clone.map(item => item.checked = this.checkAll)
      this.stocktakes = [...clone]
      this.checkedStocktakes = this.stocktakes.filter(item => item.checked === true)
    },
    clearSelection () {
      this.checkAll = false
      this.onCheckedAll()
    },
    startStockTake () {
      this.openStockTakeDialog = true
    },
    viewDetails (item) {
      let params = {
        id: item.id,
        savePage: this.currentPage,
        saveTab: this.tabs,
        saveSearch: this.searchText,
        saveFilters: this.filters.length ? this.$refs.filter.dataFilters : null
      }
      if (item.status === 'finished') {
        this.$router.push({ name: 'ClinicInventoryStockTakeSummary', params })
      } else {
        this.$router.push({ name: 'AddClinicInventoryStockTake', params })
      }
    },
    updateArchive (item) {
      if (item.archived) {
        this.isFetching = true
        let data = { archived: !item.archived }
        this.$axios.patch(`/clinics/${this.company.slug}/stock_takes/${item.id}`, data)
          .then(() => {
            this.reset()
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.isFetching = false
          })
      } else {
        this.archiveStockTake(item)
      }
    },
    archiveStockTake (item) {
      this.selectedStocktake = item
      this.openArchiveDialog = true
    },
    async confirmDelete (isMultiple = false) {
      this.isLoading = true
      if (isMultiple) {
        try {
          for (let i = 0; i < this.checkedStocktakes.length; i++) {
            await this.$axios.patch(`/clinics/${this.company.slug}/stock_takes/${this.checkedStocktakes[i].id}`, { archived: true })
          }
          this.reset()
        } catch {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        } finally {
          this.isLoading = false
        }
      } else {
        let data = { archived: !this.selectedStocktake.archived }
        this.$axios.patch(`/clinics/${this.company.slug}/stock_takes/${this.selectedStocktake.id}`, data)
          .then(() => {
            this.reset()
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    async downloadReport (item) {
      let key
      try {
        const { data } = await this.$axios.post(`users/${this.user.id}/request_otk`)
        key = data.key
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        return
      }
      let baseUrl = process.env.VUE_APP_BASE_URL
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        baseUrl = 'https://api-test.yezza.io'
      } else if (process.env.VUE_APP_ENV === 'prod') {
        baseUrl = 'https://export.yezza.io'
      }
      if (item.status === 'finished') {
        const url = `${baseUrl}/clinics/${this.company.slug}/stock_takes/${item.id}/preview_report?key=${key}`
        window.open(url,'_blank')
      }
    },
    async bulkDownload () {
      await this.checkedStocktakes.forEach(async stocktake => {
        await this.downloadReport(stocktake)
      })
    },
    reset () {
      this.clearSelection()
      this.fetchStockTakes()
      this.closed()
    },
    closed () {
      this.selectedStocktake = null
      this.openArchiveDialog = false
      this.openMultiArchiveDialog = false
    },
    goBack () {
      this.$router.push('/admin/clinic/settings')
    },
    menuPositionTop (index) {
      let position = index + 1
      if (position > 7) {
        let start = this.stocktakes.length - 3
        if (position > start) {
          return true
        }
      }
      return false
    },
  }
}
</script>

<style scoped>
.column-width {
  width: 200px;
}
::v-deep .v-data-table__wrapper table tbody tr:hover{
  cursor: pointer;
  background: var(--v-neutral200) !important; 
}
</style>